var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useEffect, useState } from "react";
import TableRow from "./TableRow";
var TableBody = function (_a) {
    var data = _a.data, columns = _a.columns, tableId = _a.tableId, rearrangeConfig = _a.rearrangeConfig;
    var _b = useState([]), boxes = _b[0], setBoxes = _b[1];
    useEffect(function () {
        var updated = data.map(function (item) { return __assign({}, item); });
        setBoxes(__spreadArray([], updated));
    }, [rearrangeConfig === null || rearrangeConfig === void 0 ? void 0 : rearrangeConfig.resetOrder]);
    var handleDrag = function (ev) {
        if (!(rearrangeConfig === null || rearrangeConfig === void 0 ? void 0 : rearrangeConfig.enable)) {
            return;
        }
        (rearrangeConfig === null || rearrangeConfig === void 0 ? void 0 : rearrangeConfig.setDragId) && (rearrangeConfig === null || rearrangeConfig === void 0 ? void 0 : rearrangeConfig.setDragId(ev.currentTarget.id));
    };
    var handleDrop = function (ev) {
        if (!(rearrangeConfig === null || rearrangeConfig === void 0 ? void 0 : rearrangeConfig.enable)) {
            return;
        }
        var dragBox = boxes.find(function (box) { return box.episodeId === Number(rearrangeConfig === null || rearrangeConfig === void 0 ? void 0 : rearrangeConfig.dragId); });
        var dropBox = boxes.find(function (box) { return box.episodeId === Number(ev.currentTarget.id); });
        (rearrangeConfig === null || rearrangeConfig === void 0 ? void 0 : rearrangeConfig.setDragSectionId) && (rearrangeConfig === null || rearrangeConfig === void 0 ? void 0 : rearrangeConfig.setDragSectionId(dragBox.channelId));
        (rearrangeConfig === null || rearrangeConfig === void 0 ? void 0 : rearrangeConfig.setnewDisplayOrder) && (rearrangeConfig === null || rearrangeConfig === void 0 ? void 0 : rearrangeConfig.setnewDisplayOrder(dropBox.displayOrder));
        var dragBoxOrder = dragBox.displayOrder;
        var dropBoxOrder = dropBox.displayOrder;
        var newBoxState = boxes.map(function (box) {
            if (box.episodeId === Number(rearrangeConfig === null || rearrangeConfig === void 0 ? void 0 : rearrangeConfig.dragId)) {
                box.displayOrder = dropBoxOrder;
            }
            if (box.episodeId === Number(ev.currentTarget.id)) {
                box.displayOrder = dragBoxOrder;
            }
            return box;
        });
        setBoxes(newBoxState);
    };
    return (React.createElement("tbody", null, (rearrangeConfig === null || rearrangeConfig === void 0 ? void 0 : rearrangeConfig.enable)
        ? boxes
            .sort(function (a, b) { return a.displayOrder - b.displayOrder; })
            .map(function (cell, index) {
            return (React.createElement(TableRow, { cell: cell, columns: columns, key: tableId + "_row_" + index, id: cell.episodeId, rearrangeConfig: rearrangeConfig, handleDrag: handleDrag, handleDrop: handleDrop }));
        })
        : data.map(function (cell, index) {
            return (React.createElement(TableRow, { cell: cell, columns: columns, key: tableId + "_row_" + index }));
        })));
};
export default TableBody;
